export const HOSPITALITY_DIGITAL_KEY_ACCESS_TYPES = ['pin', 'app', 'other'] as const;

export type HospitalityDigitalKeyAccessType = typeof HOSPITALITY_DIGITAL_KEY_ACCESS_TYPES[number];

export interface HospitalityDigitalKey {
  accessType: HospitalityDigitalKeyAccessType;
  code?: string;
  link?: string;
  notes?: string;
}

